var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThree3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2559 17.36L21.7839 14.48V12.8H13.9439V14.88H18.7119L16.4079 17.488V19.2H17.5919C19.0639 19.2 19.6879 19.728 19.6879 20.576C19.6879 21.488 18.8879 22.016 17.5919 22.016C16.4239 22.016 15.2399 21.648 14.3919 21.008L13.3839 22.992C14.4719 23.76 16.0879 24.192 17.6559 24.192C20.8399 24.192 22.2959 22.464 22.2959 20.576C22.2959 18.928 21.2719 17.68 19.2559 17.36Z",
    fill: "#5F61BE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 15.5,
    stroke: "#7476D1",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree3);
export default __webpack_public_path__ + "static/media/three3.9692db29e078be037bef0f8184898824.svg";
export { ForwardRef as ReactComponent };